import React, { Component } from 'react';

import _ from 'lodash';

import { Message } from 'semantic-grab-ui/src';
import { Col, Icon, Row } from 'grab-ui';

import MetricsStatsTable from 'omega-rtc/views/trident-campaigns/metrics/MetricsStatsTable';
import Panel from 'omega-rtc/views/ucd/Panel';
import { constructStatsTableData, constructChartProps } from 'omega-rtc/utils/ucd-utils';
import { REPORTS_KEY } from 'omega-rtc/constants/metrics';
import PerformanceSummarySection from 'omega-rtc/views/ucd/PerformanceSummarySection';
import ProgressiveContainer from 'omega-rtc/components/container/ProgressiveContainer';
import { BenchmarkMap } from 'omega-rtc/types/trident-campaigns';
import BusinessMetricsPanel from 'omega-rtc/views/ucd/BusinessMetricsPanel';

import { EquationBarGraph } from 'rtc-widget';


import './UCDHomePage.scss';
import './CampaignDetail.scss';

type Props = {
  projectView: Object,
  campaignView: Object,
  campaignMetricsView: Object,
  businessMetrics: Object,
  campaignBizMetricsColumns: Object,
  subObjective: string,
  isLoadingBenchmark: boolean,
  metricsBenchmark: BenchmarkMap,
};

class TridentMetricsPage extends Component {
  props: Props

  getMetricsPageUrl(countryID: string, campaignId: string) {
    return `${window.Grab.config.OMEGA_RTC_URI}/campaigns/${countryID}/${campaignId}/metrics`;
  }

  renderNoBenchmarkMessage() {
    return (
      <Message info>
        <p style={{ marginLeft: 30 }}>
          <span style={{ position: 'absolute', left: 25, top: 16 }}> <Icon type="exclamation-circle" /> </span>
          We are collecting data to generate benchmarks for you. Please come back later.
        </p>
      </Message>
    );
  }

  render() {
    const {
      projectView,
      campaignView,
      campaignMetricsView,
      businessMetrics,
      campaignBizMetricsColumns,
      subObjective,
      metricsBenchmark,
      isLoadingBenchmark,
    } = this.props;

    const commsMetrics = _.get(campaignMetricsView, 'comms', {});
    const summaryMetrics = _.get(campaignMetricsView, 'summary', {});

    const lastUpdatedDate = _.get(campaignMetricsView, 'lastUpdated', {});
    const tridentMetricsPageUrl = this.getMetricsPageUrl(
      _.get(projectView, 'project.countryID'),
      _.get(campaignView, 'campaign.mamCampaignID')
    );
    const channelToStatsMap = constructStatsTableData(commsMetrics);
    const headerMetricsProps = constructChartProps(summaryMetrics);

    const { objective } = campaignView;

    return (
      <div className="project-performance-metrics campaign-performance-metrics">
        {!_.isEmpty(businessMetrics) &&
          <BusinessMetricsPanel
            objective={objective}
            subObjective={subObjective}
            campaignBizMetricsColumns={campaignBizMetricsColumns}
            businessMetrics={businessMetrics}
          />
        }
        {!_.isEmpty(channelToStatsMap) &&
          <Panel title={'Communication Metrics'} reports={_.get(campaignMetricsView, REPORTS_KEY)}>
            <Row style={{ marginTop: 0 }} className="">
              <Col span={24}>
                <div style={{ margin: '32px 0' }}>
                  <EquationBarGraph {...headerMetricsProps} />
                </div>
                <p className={'detail-statistic-hyperlink'}><a
                  href={tridentMetricsPageUrl}
                  target={'_blank'}
                >View in-depth
                  statistic</a></p>
                <div>
                  <ProgressiveContainer
                    style={{ height: 'auto', minHeight: 45 }} message={'Loading Benchmarks ...'}
                    isLoading={isLoadingBenchmark}
                  >
                    {!_.isEmpty(metricsBenchmark) ?
                      <PerformanceSummarySection metricsStat={channelToStatsMap} metricsBenchmark={metricsBenchmark} />
                      : this.renderNoBenchmarkMessage()
                    }
                  </ProgressiveContainer>
                  <MetricsStatsTable
                    headerTitle={'Channel'} metricsStat={channelToStatsMap}
                    nodeType={'scenarios'} lastUpdatedDate={lastUpdatedDate}
                    metricsBenchmark={metricsBenchmark}
                  />
                </div>
              </Col>
            </Row>
          </Panel>
        }
      </div>
    );
  }
}

export default TridentMetricsPage;
